import {Redirect} from "react-router-dom";
import SentryRoute from './SentryRoute';
import {useGlobalState} from "./GlobalState";

function PrivateRoute(props) {
    const [pupilId,] = useGlobalState("selectedPupil")

    return (
        <>
            {props.userIsAuthenticated ?
                <SentryRoute
                    key={pupilId}
                    path={props.path}
                    exact={props.exact}
                    component={props.component}
                />
                :
                <Redirect to={'/login'}/>
            }
        </>
    )
}

export default PrivateRoute;